export const getPaymentLinkManual = state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/getters.js